import React from 'react';
import styled from 'styled-components';
import {useSelector} from 'react-redux';
import PropTypes from 'prop-types';
import {riskFactorShape} from '../../../../CanvasForm/shapes';
import Utility from '../../../../../../util/utilityfunctions';
import {labels} from '../../../../../../util/utils';
import {useEngagementId} from '../../../../../../util/customHooks';
import {useIsDrawerMode} from '../../../../../../util/Ares/customHooks';
import {riskTypes} from '../../../../../../util/uiconstants';
import EllipseControl from '../../../../EllipsesControl/EllipsesControl';
import TextLink from '../../../../BaseComponentWrappers/MotifTextLink';
import {getRiskFactorsSlice} from '../../../../../../selectors/ISA315/selectors';
import {getTaskDocumentByDocumentId} from '../../../../../../selectors/Ares/selectors';

function RiskFactorsListItem({riskFactorId, isDisabled}) {

	const engagementId = useEngagementId();
	const riskFactor = useSelector((state) => getRiskFactorsSlice(state)?.byId[riskFactorId]);
	const aresDocument = useSelector((state) => getTaskDocumentByDocumentId(state, riskFactor?.documentId));

	const isDrawerMode = useIsDrawerMode();
	const queryParameters = isDrawerMode ? {isDrawer: true} : {};

	let riskFactorSectionUrl;
	if (riskFactor) {
		riskFactorSectionUrl = Utility.getAresTaskListNavigationUrl(
			riskFactor.documentId,
			riskFactor.formHeaderId,
			riskFactor.formSectionId,
			engagementId,
			riskFactor.taskId,
			queryParameters,
			aresDocument?.documentTypeId
		);
	}

	return (
		<>
			<StyledRiskFactorsListItem className="StyledRiskFactorsListItem">
				<span className="riskfactor-name">
					<TextLink
						className="riskfactor-link"
						variant="alt"
						href={riskFactorSectionUrl}
						isEllipsed
						label={riskFactor?.riskFactorName}
						tooltipClass="tooltipCustomWidth"
					/>
				</span>
				{riskFactor?.customDescription?.length > 0 && (
					<span className="riskfactor-description">
						<EllipseControl
							content={riskFactor.customDescription}
							tooltip={riskFactor.customDescription}
							noOfLines={2}
							tooltipClass="tooltipCustomWidth"
						/>
					</span>
				)}
				{riskFactor?.rationale?.length > 0 && riskFactor.riskTypeId === riskTypes.NOTAROMM && (
					<>
						<span className="riskfactor-rationale-header">{labels.rationaleLabel + ': '}</span>
						<span className="riskfactor-rationale">{riskFactor.rationale}</span>
					</>
				)}
			</StyledRiskFactorsListItem>
		</>
	);
}

RiskFactorsListItem.propTypes = {
	riskFactor: riskFactorShape.isRequired,
	isDisabled: PropTypes.bool
};

export default RiskFactorsListItem;

const StyledRiskFactorsListItem = styled.li`
	padding: 0;
	border: none;
	.riskfactor-name {
		display: block;
		width: 100%;
		padding-right: var(--px-40);
		padding-bottom: var(--px-10);
		.riskfactor-link {
			display: block;
			width: 100%;
			font-size: var(--px-14);
			box-shadow: none;
			border: none;
			&:hover {
				color: var(--blue-600);
			}
		}
	}
	.riskfactor-description {
		display: block;
		width: 100%;
		padding-bottom: var(--px-5);
	}
`;
